const euroFormatter = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Format a number as Euro currency: "1 234,56 €" */
export const formatEuro = (value: number | string | null | undefined): string => {
  if (value == null) return "—";
  const num = typeof value === "string" ? Number.parseFloat(value) : value;
  return Number.isFinite(num) ? euroFormatter.format(num) : "—";
};

/** Format a number with locale separators (no currency symbol) */
export const formatNumber = (
  value: number | string | null | undefined,
  options?: { minimumFractionDigits?: number; maximumFractionDigits?: number },
): string => {
  if (value == null) return "—";
  const num = typeof value === "string" ? Number.parseFloat(value) : value;
  if (!Number.isFinite(num)) return "—";
  return new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: options?.minimumFractionDigits ?? 0,
    maximumFractionDigits: options?.maximumFractionDigits ?? 0,
  }).format(num);
};
